module.exports = __webpack_public_path__ + "img/img_shouye_duichong@2x.5be0c2ad.png";